import { JSX } from 'react'


import { HttpBody } from '@/lib/request.js'

import * as contract_storage from '@/storage/contract.js'


// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Field from '@/components/ui/field.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Fieldset from '@/components/ui/fieldset.tsx'




export default function
(
	props: {
		doc: HttpBody<contract_storage.TRawDocumentType>

		update(name: string, value: unknown): void

	},

)
:	JSX.Element
{
	let { office, salary, bonus, begin, finish, begin_ordeal, finish_ordeal, resigned } = props.doc

	let on_update = (name: string, value: unknown): void =>
	{
		props.update(name, value)

	}

	return (
		<Fieldset.Root divide name="签约信息">
			<Fieldset.Group>
				<Field.Text label="岗位" name="office" value={office ?? ''} change={on_update} />

				<Field.RealNumber label="月薪" name="salary" min={0} value={salary} change={on_update} />

				<Field.RealNumber label="年终奖金" name="bonus" min={0} value={bonus} change={on_update} />

			</Fieldset.Group>

			<Fieldset.Group>
				<Field.Date label="协议起始日期" name="begin" value={begin} change={on_update} />

				<Field.Date label="协议截止日期" name="finish" value={finish} change={on_update} />

				<Field.Date label="试用起始日期" name="begin_ordeal" value={begin_ordeal} change={on_update} />

				<Field.Date label="试用截止日期" name="finish_ordeal" value={finish_ordeal} change={on_update} />

			</Fieldset.Group>

			<Fieldset.Group>
				<Field.Date label="离职日期" name="resigned" value={resigned} change={on_update} />

			</Fieldset.Group>

		</Fieldset.Root>

	)

}
